import React, { Component } from 'react';

import { RadioMolecule } from '../../molecules';
import { TextInput } from '../../atoms';

export class RadioWithOther extends Component {

  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  renderOther() {
    const {
      label,
      id,
      placeholder,
      value,
      error,
      disabled,
      changeActionToRadio,
      name
    } = this.props;

   return   (
     <div>
      <p onClick={() => this.toggle()} className="toggle-button">Escolher opção</p>
      <TextInput
        id={id}
        type="text"
        placeholder={placeholder}
        label="Informe a unidade de medida"
        value={value}
        error={error}
        changeAction={changeActionToRadio}
        name={name}
      />
     </div>
    );
  }

  toggle() {
    this.props.changeActionToRadio({ target: { name: this.props.name, id:  this.props.id, value: ""}});
    this.setState({active: !this.state.active});
  }

  render() {
    const {
      label,
      options,
      align,
      items,
      id,
      placeholder,
      value,
      error,
      disabled,
      changeActionToText,
      changeActionToRadio,
      name
    } = this.props;
    return (
      <div className="radio-with-other">
        <RadioMolecule
          options={options}
          changeAction={changeActionToRadio}
          value={value}
          align={align}
          label={label}
          name={name}
          id={id}
        />
        {this.state.active || this.props.value.length > 1 ? this.renderOther() : <p onClick={() => this.toggle()} className="toggle-button">Outro</p>}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// src/components/common/RadioWithOther.js